import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { addPropertyPrefix } from 'utils/propertyChangeAdapters';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { TableCell, TableRow } from '@mui/material';
import Delete from '@mui/icons-material/Delete';
import { DynamicField, IconButton, TextField } from '@totalsoft/rocket-ui';
import curry from 'lodash.curry';

const getDynamicInputParams = paramTypeCode => {
  switch (paramTypeCode) {
    case 'I':
      return { controlType: 'Numeric' };
    case 'P':
      return { controlType: 'Numeric', inputProps: { decimalScale: 2, thousandseparator: '' } };
    case 'N':
    case 'P6':
      return { controlType: 'Numeric', inputProps: { decimalScale: 6, thousandseparator: '' } };
    case 'D':
      return { controlType: 'Date' };
    case 'A':
      return { controlType: 'Numeric', inputProps: { decimalScale: 2, thousandseparator: '' } };
    case 'B':
      return { controlType: 'Checkbox' };
    default:
      return { controlType: 'Text' };
  }
};

const OfferPaymentPlanScheduleParamsRowComponent = ({ item, idx, onPropertyChange, validationScheduleParam, onDelete, t }) => {
  const [dynamicInputParams] = useState(getDynamicInputParams(item.paramTypeCode));

  const handleParamValueChanged = curry((_, value) => {
    onPropertyChange(item.scheduleTypeParamId, value);
  });

  const handleRowDelete = useCallback(() => {
    onDelete(item.scheduleTypeParamId);
  }, [item.scheduleTypeParamId, onDelete]);

  return (
    <TableRow>
      <TableCell>
        <TextField
          id={'scheduleParam_name_' + idx}
          name={'scheduleParamName'}
          fullWidth
          value={item.originalValue ? `${item.typeParamDisplayName} ( ${item.originalValue} )` : item.typeParamDisplayName || ''}
          helperText={
            item.originalValue && item.typeParamName === '@GlobalRescheduleRate' && parseInt(item.originalValue) > parseInt(item.paramValue)
              ? t('OfferEdit.PaymentPlan.ScheduleParametersWarnings', {
                  newValue: item.paramValue,
                  originalValue: parseInt(item.originalValue) - 1
                })
              : ''
          }
          disabled={true}
        />
      </TableCell>
      <TableCell>
        <DynamicField
          id={'scheduleParam_value_' + idx}
          controlType={dynamicInputParams.controlType}
          inputProps={dynamicInputParams.inputProps}
          value={item.paramValue || ''}
          checked={item.paramValue}
          fullWidth
          onChange={addPropertyPrefix(idx, handleParamValueChanged)('paramValue')}
          error={!isValid(validationScheduleParam[idx].paramValue)}
          helperText={getErrors(validationScheduleParam[idx].paramValue)}
        />
      </TableCell>
      <TableCell align='right'>
        <IconButton
          id={'scheduleParam_' + idx + '_deleteBtn'}
          color='primary'
          variant='text'
          size='small'
          tooltip={t('Delete')}
          onClick={handleRowDelete}
          disabled={Boolean(item.originalValue)}
        >
          <Delete />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

OfferPaymentPlanScheduleParamsRowComponent.propTypes = {
  item: PropTypes.object.isRequired,
  idx: PropTypes.number.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  validationScheduleParam: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  t: PropTypes.func
};

export default withTranslation()(OfferPaymentPlanScheduleParamsRowComponent);
